import { isMapId, MAPS, type MapId } from "@69ly/maps";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mapIconUrl } from "../lib/map-art.ts";

const KEY = "69ly.team.map";

/** The Team page's map, kept in this browser: Who plays where and Who knows what both follow it. */
export function useTeamMap(): [MapId, (m: MapId) => void] {
  const [map, setMap] = useState<MapId>(() => {
    try {
      const saved = window.localStorage.getItem(KEY) ?? window.localStorage.getItem("69ly.positions.map");
      return isMapId(saved) && MAPS.some((m) => m.id === saved && m.activeDuty) ? saved : "de_mirage";
    } catch {
      return "de_mirage";
    }
  });
  const set = (m: MapId) => {
    setMap(m);
    try {
      window.localStorage.setItem(KEY, m);
    } catch {
      // No storage: the choice lasts for this visit.
    }
  };
  return [map, set];
}

/** The Active Duty maps as a row of badges: one pick for the sections under it. */
export function TeamMapBar({ map, onPick }: { map: MapId; onPick: (m: MapId) => void }) {
  const { t } = useTranslation();
  return (
    <section className="team-map-bar" aria-labelledby="team-map-title">
      <div>
        <h2 id="team-map-title" className="eyebrow">
          {t("teamMap.title")}
        </h2>
        <p className="muted small">{t("teamMap.help")}</p>
      </div>
      <div className="team-maps" role="group" aria-label={t("teamMap.title")}>
        {MAPS.filter((m) => m.activeDuty).map((m) => (
          <button key={m.id} type="button" className="live-map-choice team-map-choice" aria-pressed={map === m.id} onClick={() => onPick(m.id)}>
            <img src={mapIconUrl(m.id)} alt="" width={28} height={28} />
            {m.name}
          </button>
        ))}
      </div>
    </section>
  );
}
